import type { TemplateEditorStore } from 'bz-clinical/controls/template-editor/template-editor-store';
import { FieldSelect } from 'bz-core-controls';
import { Show } from 'bz-core-controls';
import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import type { ScoresGoalsSettingsResponse } from 'tm3-core/api.dtos';
interface ScoreEditorProps {
  templateEditorStore: TemplateEditorStore;
  value?: ScoresGoalsSettingsResponse;
  onChange: (e: any) => void;
}

enum PickMode {
  None,
  Scores,
  Goals
}

@inject('templateEditorStore')
@observer
class ScoreEditor extends React.Component<ScoreEditorProps> {
  @observable pickMode: PickMode = PickMode.None;

  pickModeDropdownValues = [
    { display: 'None', value: PickMode.None },
    { display: 'Score', value: PickMode.Scores },
    { display: 'Goal', value: PickMode.Goals }
  ];

  constructor(props: ScoreEditorProps) {
    super(props);
    if (props.value) {
      this.pickMode = props.value.type === 'S' ? PickMode.Scores : PickMode.Goals;
    }
  }

  @action.bound
  handlePickModeChange(e) {
    const newVal = e.target.value;
    if (this.pickMode !== newVal) {
      this.pickMode = e.target.value;
      this.props.onChange(undefined);
    }
  }

  @computed
  get scoreGoalItems() {
    const { scoreTypes, goalTypes } = this.props.templateEditorStore;
    return this.pickMode ? (this.pickMode === PickMode.Scores ? scoreTypes : goalTypes) : undefined;
  }

  render() {
    const value = this.props.value ? this.props.value.id : null;

    return (
      <div style={{ width: 200 }}>
        <FieldSelect
          items={this.pickModeDropdownValues}
          value={this.pickMode}
          displayMember="display"
          valueMember="value"
          onChange={this.handlePickModeChange}
          fullWidth={true}
        />
        <Show if={this.pickMode !== PickMode.None}>
          <FieldSelect
            items={this.scoreGoalItems}
            value={value}
            displayMember="name"
            valueMember="id"
            onChange={this.onChange}
            includeNone={true}
            noneValue={null}
            fullWidth={true}
          />
        </Show>
      </div>
    );
  }

  @action.bound
  onChange(e) {
    const { scoreGoalItems, props } = this;
    const { scoreTypes, goalTypes } = props.templateEditorStore;

    if (!!scoreGoalItems) {
      this.props.onChange(scoreGoalItems.find((sc) => sc.id === e.target.value));
    }
  }
}

export default ScoreEditor;
